import MuiAlert from "@mui/lab/Alert";
import { Snackbar, SnackbarCloseReason } from "@mui/material";
import { SyntheticEvent, useEffect, useState } from "react";

interface Props {
	message: string | null;
	onHide: () => void;
	severity?: "error" | "info" | "success" | "warning";
}

export const NotificationSnackBar = ({
	message,
	onHide = () => {},
	severity = "success",
}: Props) => {
	const handleClose = (
		event?: SyntheticEvent | Event,
		reason?: SnackbarCloseReason,
	) => {
		if (reason === "clickaway") {
			return;
		}
		onHide();
	};
	const [open, setOpen] = useState(true);
	useEffect(() => {
		setOpen(!!message);
	}, [message]);

	return (
		<Snackbar
			open={open}
			autoHideDuration={2500}
			onClose={handleClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
		>
			<MuiAlert
				elevation={6}
				variant="filled"
				severity={severity}
				onClose={handleClose}
			>
				{message}
			</MuiAlert>
		</Snackbar>
	);
};
